/**
 *
 * ResourceItemInfoButton
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import MixPanel from 'utils/mixpanelService';
import ClassNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import NewTabIcon from './images/new-tab.svg';

const styles = theme => ({
  linkBtn: {
    minWidth: 32,
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  borderBtn: {
    border: '1px solid #979797',
    minWidth: 102,
  },
  websiteBtn: {
    width: 160,
    height: 49,
    borderRadius: 5,
    padding: 2,
    margin: 0,
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    fontSize: 12,
    fontFamily: 'MadaMedium',
    textTransform: 'none',
    display: 'flex',
    justifyContent: 'flex-start',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  icon: {
    marginLeft: 23,
    marginRight: 15,
  },
});

class ResourceItemInfoButton extends React.PureComponent {
  handleButtonClick = () => {
    const {
      name,
      resourceType,
      exitPage,
      subtype,
      blog,
      trackMessage,
      url,
    } = this.props;
    const trackProperties = {
      name,
      type: resourceType,
      exitPage,
      subtype,
      blog,
    };
    MixPanel.track(trackMessage, trackProperties);
    window.open(url, '_blank', 'noopener');
  };

  render() {
    const { classes, children, type, label, withBorder } = this.props;
    if (type === 'website')
      return (
        <Grid item className={classes.linkBtnWrapper}>
          <Button
            onClick={this.handleButtonClick}
            variant="text"
            disableFocusRipple
            className={classes.websiteBtn}
          >
            <img src={NewTabIcon} alt="New Tab" className={classes.icon} />
            {label || 'Official Site'}
          </Button>
        </Grid>
      );
    return (
      <Grid item className={classes.linkBtnWrapper}>
        <Button
          disableFocusRipple
          onClick={this.handleButtonClick}
          className={ClassNames(
            classes.linkBtn,
            withBorder && classes.borderBtn,
          )}
        >
          {children}
        </Button>
      </Grid>
    );
  }
}

ResourceItemInfoButton.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
  type: PropTypes.string,
  url: PropTypes.string,
  trackMessage: PropTypes.string,
  resourceType: PropTypes.string,
  name: PropTypes.string,
  exitPage: PropTypes.string,
  label: PropTypes.string,
  subtype: PropTypes.string,
  withBorder: PropTypes.bool,
  blog: PropTypes.bool,
};

export default withStyles(styles)(ResourceItemInfoButton);
